import styled from "styled-components";
import { 
  Input as AntInput,
} from "antd";

export const InputContainer = styled.div`

  .float-label {
  position: relative;
}

.label {
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 24px;
  top: 14px;
  transition: 0.2s ease all;
}

.as-placeholder {
  color: gray;
  line-height: 2;
}

.as-label {
  z-index: 20;
  top: -8px;
  font-size: 12px !important;
  padding: 0 4px;
  background: white;
  padding: 0 4px;
  margin-left: -4px;
}
`

export const Input = styled(AntInput)`
  border-radius: 34px;
  border: 1.5px solid #DEDEDE;
  height: 52px;
  padding-left: 24px;
  font-size: 16px !important;
`